import { render, staticRenderFns } from "./OurPolitics.vue?vue&type=template&id=24f5d7f2&scoped=true"
import script from "./OurPolitics.vue?vue&type=script&setup=true&lang=js"
export * from "./OurPolitics.vue?vue&type=script&setup=true&lang=js"
import style0 from "./OurPolitics.vue?vue&type=style&index=0&id=24f5d7f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f5d7f2",
  null
  
)

export default component.exports